//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { RoomModel } from "@app/catalog";
import { PresenterType } from "@app/shared";

@PresenterType({
  model: RoomModel,
  key: 'tileTop'
})
@Component({
  selector: 'room-carousel-item',
  templateUrl: './room-carousel-item.component.html',
  styleUrl: './room-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RoomCarouselItemComponent {
  public data: WritableSignal<RoomModel> = signal<RoomModel>(undefined);
}
